/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/ResourceLocation
 * @desc ResourceLocation filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import type React from 'react';
import FilterPostReportResourceLocationForm from './Form';
import type { FilterPostNewIndexResourceLocationProps } from './types';

const metadataNameCapitalised =
  ResourceLocation.getHumanReadableEntityName(false, true);

export const FilterPostNewIndexResourceLocation: React.FC<
  FilterPostNewIndexResourceLocationProps
> = ({ addPostFilter, ...rest }) => (
  <Modal
    header={`Filter by ${metadataNameCapitalised}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportResourceLocationForm
        addPostFilter={addPostFilter}
        onDone={toggleModal}
      />
    )}
    {...rest}
  />
);
